import * as React from 'react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import Tooltip from 'modules/timeoff/components/Leaves/Overview/NewStatsCounter/Tooltip'
import type Allowance from 'modules/timeoff/store/models/Allowance'
import type { Cycle } from 'modules/timeoff/store/models/AllowanceStat'

import Accrued from './Accrued'
import Advance from './Advance'
import Carryovers from './Carryovers'
import Incidence from './Incidence'

interface Props {
  accrued: number
  allowance: Allowance
  carryOver: number
  incidence: number
  currentCycle: Cycle
  nextCycle: Cycle | null | undefined
  advance: number
}

const AvailableTooltip = ({
  accrued,
  allowance,
  carryOver,
  incidence,
  currentCycle,
  nextCycle,
  advance,
}: Props) => {
  const title = allowance.isDays
    ? i18n.t('time_off.available_tooltip.available_days')
    : i18n.t('time_off.available_tooltip.available_hours')

  return (
    <Tooltip title={title}>
      <>
        <Accrued amount={accrued} currentCycle={currentCycle} />
        {carryOver > 0 && accrued > carryOver && <Carryovers amount={carryOver} />}
        {incidence > 0 && accrued > carryOver && <Incidence allowanceIncidence={incidence} />}
        {advance < 0 && <Advance amount={advance} nextCycle={nextCycle} />}
      </>
    </Tooltip>
  )
}

export default observer(AvailableTooltip)
